<template>
  <div class="sr-wrap sr-wrap--center">
    <div v-if="!registerFlag" class="sr-box sr-box--mini">
      <div class="sr-box__header">
        <div class="sr-box__title">{{t('user.forgetPassword.title.text_1')}}</div>
      </div>
      <div :class="['sr-box__content' ,localCN?'':'error-static']">
        <el-form ref="formRef" :model="form.fields" :rules="form.rules">
          <div v-if="VISIBLE.CELLPHONE">
            <el-form-item prop="cellphone">
              <div class="sr-box__comb-item">
                <div class="comb-item__select">
                  <sr-zone-number v-model:zone-number="form.fields.zoneNumber"></sr-zone-number>
                </div>
                <div class="comb-item__input">
                  <el-input v-model="form.fields.cellphone" :placeholder="form.schema.cellphone.label"></el-input>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="smsCode">
              <div class="sr-box__comb-item">
                <div class="comb-item__input">
                  <el-input v-model="form.fields.smsCode" :placeholder="form.schema.smsCode.label"></el-input>
                </div>
                <div class="comb-item__btn">
                  <sr-cellphone-code-btn :cellphone="form.fields.cellphone" v-model:sms-id="form.fields.smsId"></sr-cellphone-code-btn>
                </div>
              </div>
            </el-form-item>
          </div>

          <div v-if="VISIBLE.EMAIL">
            <el-form-item prop="email">
              <el-input v-model="form.fields.email" @blur="handleEmailBlur" :placeholder="form.schema.email.label"></el-input>
            </el-form-item>
            <el-form-item prop="emailCode">
              <div class="sr-box__comb-item">
                <div class="comb-item__input">
                  <el-input v-model="form.fields.emailCode" :placeholder="form.schema.emailCode.label"></el-input>
                </div>
                <div class="comb-item__btn">
                  <sr-email-code-btn :email="form.fields.email" v-model:email-id="form.fields.emailId" :disabled="DISABLED.EMAIL_CODE" type="5"></sr-email-code-btn>
                </div>
              </div>
            </el-form-item>
          </div>

          <el-form-item prop="password">
            <el-input v-model="form.fields.password" :placeholder="form.schema.password.placeholder" type="password"></el-input>
          </el-form-item>
          <el-form-item prop="confirmPwd">
            <el-input v-model="form.fields.confirmPwd" :placeholder="form.schema.confirmPwd.label" type="password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="sr-box__footer">
        <div class="sr-box__btn">
          <el-button type="primary" @click="handleSubmit">{{ t('global.btn.submit') }}</el-button>
        </div>
        <div :class="['sr-box__btn--text',localCN?'support-cn':'support-en']">
          <div>
            <el-button type="text" @click="toLogin()">{{t('user.register.content.text_4')}}</el-button>
          </div>
          <div>
            <el-button type="text" @click="handleResetMode()">{{ t(`global.btn.${resetMode}`) }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="registerFlag" class="sr-box sr-box--mini">
      <div class="sr-box__header">
        <img class="sr-success" src="../../assets/img/success.png" alt="">
      </div>
      <div class="sr-box__content">
        <div>
          <span>{{t('user.forgetPassword.content.text_1')}}</span>
        </div>
        <div>
          <span class="sr-count-down">{{t('user.forgetPassword.content.text_1',{timeout:timeout})}}</span>
        </div>
      </div>
      <div class="sr-box__footer">
        <div class="sr-box__btn">
          <el-button type="primary" @click="backToLogin">{{t('user.forgetPassword.content.text_3')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed, onBeforeMount } from 'vue'
import { formComp, commonComp, validatorComp } from '@/compositions'
import { routeTo } from '@/utils'
// import { platformChannel } from '@/config/setting.config'
import SrZoneNumber from '@/components/SrZoneNumber'
import SrCellphoneCodeBtn from '@/components/SrCellphoneCodeBtn'
import SrEmailCodeBtn from '@/components/SrEmailCodeBtn'
import { ForgetPasswordReq } from '@/domain/modules/forget-password'
import { resetPasswordByEmail, resetPasswordByCellphone } from '@/api/modules/user'
import { useI18n } from '@/plugins/i18n'
import { commonUtils, encryptUtils } from '@libs/utils'

export default {
  name: 'ForgetPassword',
  components: {
    SrZoneNumber,
    SrCellphoneCodeBtn,
    SrEmailCodeBtn
  },
  setup() {
    const { createForm, resetForm } = formComp()
    const { validateConfirmPwd } = validatorComp()
    const { dict, constant: { RESET_MODE } } = commonComp()
    const { t } = useI18n()

    // todo - comp
    const scopedComp = {
      dict,
      t
    }

    // todo - refs
    const refs = reactive({
      formRef: null
    })

    // todo - data
    const state = reactive({
      form: createForm({ items: ForgetPasswordReq }),
      resetMode: RESET_MODE.EMAIL,
      registerFlag: false,
      timeout: 3,
      enabledCfg: {
        email: false
      },
    })

    // todo - computed
    const scopedComputed = {
      VISIBLE: computed(() => {
        return {
          CELLPHONE: (() => {
            return state.resetMode === RESET_MODE.CELLPHONE
          })(),
          EMAIL: (() => {
            return state.resetMode === RESET_MODE.EMAIL
          })()
        }
      }),
      DISABLED: computed(() => {
        return {
          EMAIL_CODE: (() => {
            return state.enabledCfg.email
          })()
        }
      })
    }

    // todo - methods
    const scopedMethods = {
      reset() {
        resetForm(state.form)
      },
      toLogin: () => {
        routeTo('/login')
      },
      handleEmailBlur: () => {
        state.form.fields.email = state.form.fields.email.trim()
        refs.formRef.validateField('email', valid => {
          state.enabledCfg.email = !valid
        })
      },
      handleSubmit: commonUtils.throttle(function() {
        refs.formRef.validate(async valid => {
          if (valid) {
            const password = encryptUtils.encrypt(state.form.fields.password)

            if (state.resetMode === RESET_MODE.CELLPHONE) {
              await resetPasswordByCellphone({
                zoneNumber: state.form.fields.zoneNumber,
                mobile: state.form.fields.cellphone,
                smsId: state.form.fields.smsId,
                code: state.form.fields.smsCode,
                password: password,
              })
            } else {
              await resetPasswordByEmail({
                email: state.form.fields.email,
                emailId: state.form.fields.emailId,
                emailCode: state.form.fields.emailCode,
                password: password,
              })
            }
            scopedMethods.successTimeout()
          }
        })
      }),
      handleResetMode() {
        state.resetMode = state.resetMode === RESET_MODE.CELLPHONE ? RESET_MODE.EMAIL : RESET_MODE.CELLPHONE
        scopedMethods.reset()
      },
      successTimeout() {
        state.registerFlag = true
        const timer = setInterval(() => {
          state.timeout--
          if (state.timeout === 0) {
            clearInterval(timer)
            scopedMethods.backToLogin()
          }
        }, 1000)
      },
      backToLogin() {
        routeTo('/login')
      }
    }

    // todo - hooks
    onBeforeMount(() => {
      state.form.rules.confirmPwd.push({
        trigger: 'blur',
        validator: (rule, value, callback) => validateConfirmPwd(rule, value, callback, { password: state.form.fields.password })
      })
    })

    return {
      ...scopedComp,
      ...toRefs(refs),
      ...toRefs(state),
      ...scopedComputed,
      ...scopedMethods
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .support-en {
    display: flex;
    justify-content: space-between;
  }

  .support-cn {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 620px) {
    .support-en {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }
  }

  .sr-success {
    display: block;
    margin: 0 auto;
  }

  .sr-box__content {
    text-align: center;

    .sr-count-down {
      font-size: 12px;
      line-height: 24px;
      color: #666;
    }
  }

  .sr-box__footer {
    margin-top: 16px;
  }

  .sr-wrap {
    height: auto;
  }
</style>
